var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "84px",
    height: "56px",
    viewBox: "0 0 84 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "credit card/Mastercard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "credit-card/Mastercard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mastercard"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.5030508 C0,1.56836927 1.56614227,0 3.50243121,0 L80.4975688,0 C82.4319081,0 84,1.57095441 84,3.5030508 L84,52.4969492 C84,54.4316307 82.4338577,56 80.4975688,56 L3.50243121,56 C1.56809187,56 0,54.4290456 0,52.4969492 L0,3.5030508 Z",
    id: "Rectangle-Copy-4",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mc_symbol",
    transform: "translate(18.666667, 12.833333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 46.4510101,
    height: 30.2984674
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FF5F00",
    x: 17.1005051,
    y: 5.27869732,
    width: 12.2535354,
    height: 19.7375862
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3626263,15.1492337 C18.3595496,11.2982955 20.1520839,7.65982169 23.2237374,5.28218391 C18.0054814,1.23775752 10.5118566,1.8268632 6.00918107,6.6354933 C1.50650552,11.4441234 1.50650552,18.8578306 6.00918107,23.6664607 C10.5118566,28.4750908 18.0054814,29.0641965 23.2237374,25.0197701 C20.1511064,22.6413773 18.3584626,19.0013954 18.3626263,15.1492337 Z",
    id: "Path",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.625404,23.4295925 L42.625404,22.6093905 L42.8198485,22.6093905 L42.8198485,22.4396935 L42.3570707,22.4396935 L42.3570707,22.6093905 L42.5398485,22.6093905 L42.5398485,23.4295925 L42.625404,23.4295925 Z M43.5237374,23.4295925 L43.5237374,22.4396935 L43.3837374,22.4396935 L43.220404,23.1467642 L43.0570707,22.4396935 L42.9170707,22.4396935 L42.9170707,23.4295925 L43.0181818,23.4295925 L43.0181818,22.6800975 L43.1698485,23.3235319 L43.2748485,23.3235319 L43.4265152,22.6800975 L43.4265152,23.4295925 L43.5237374,23.4295925 Z",
    id: "Shape",
    fill: "#F79E1B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8171717,15.1492337 C43.8170581,19.9549334 41.0346438,24.3387172 36.6516307,26.4387753 C32.2686176,28.5388334 27.0545014,27.9864729 23.2237374,25.0162835 C26.2940506,22.6366272 28.0867199,18.9986371 28.0867199,15.1474904 C28.0867199,11.2963437 26.2940506,7.65835366 23.2237374,5.27869732 C27.0545014,2.30850793 32.2686176,1.75614749 36.6516307,3.85620558 C41.0346438,5.95626367 43.8170581,10.3400475 43.8171717,15.1457471 L43.8171717,15.1492337 Z",
    id: "Path",
    fill: "#F79E1B"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.1e40a68aa7cdeb1c4f36445028d617a1.svg";
export { ForwardRef as ReactComponent };